import { render, staticRenderFns } from "./SchoolGroup.vue?vue&type=template&id=6bcd4940&scoped=true&"
import script from "./SchoolGroup.vue?vue&type=script&lang=js&"
export * from "./SchoolGroup.vue?vue&type=script&lang=js&"
import style0 from "./SchoolGroup.vue?vue&type=style&index=0&id=6bcd4940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcd4940",
  null
  
)

export default component.exports